import { render } from "./MaterialChartPanel.vue?vue&type=template&id=e55fb72c&scoped=true"
import script from "./MaterialChartPanel.vue?vue&type=script&lang=js"
export * from "./MaterialChartPanel.vue?vue&type=script&lang=js"

import "./MaterialChartPanel.vue?vue&type=style&index=0&id=e55fb72c&lang=css&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e55fb72c"]])

export default __exports__